import { getLocales } from '@change-corgi/config/locales';
import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_FUTURE_SAP_MEDIA_DISCLAIMER = defineFcm('future_sap_media_disclaimer')
	.asJson(
		createShapeNormalizer({
			type: 'record',
			keys: getLocales(),
			optionalValues: true,
			shape: { type: 'boolean', optional: true },
		}),
	)
	.withDefault({})
	.toConfig({
		owner: 'TBD',
		scope: 'corgi-front-end',
		context: "Start A Petition's media upload page",
		description: `This country and locale fcm enables showing a media consent disclaimer right beneath media upload area.
	For the country you want to enable, create a json there to show which locale(s) are also required.
	Example: South Africa (za): { "en-GB": true } (or { "en-GB": true, "en-US" : true }).`,
		import: false,
		template: {
			'en-GB': true,
		},
	});
